import React from 'react'
import { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const RvnIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <G clipPath='url(#clip0_10859_99573)'>
                <Path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8 12H24V24H0V12H3V8H8V12ZM4.962 19.071L6.462 22H8.23V21.923L6.5 18.653C6.98 18.438 7.338 18.147 7.574 17.783C7.81 17.418 7.929 16.963 7.929 16.418C7.929 15.648 7.672 15.053 7.159 14.632C6.647 14.21 5.918 14 4.973 14H2V22H3.648V19.071H4.962ZM3.648 17.736V15.336H4.973C5.416 15.336 5.745 15.443 5.959 15.659C6.173 15.875 6.28 16.172 6.28 16.549C6.28 16.919 6.167 17.209 5.94 17.42C5.712 17.631 5.392 17.736 4.978 17.736H3.648ZM12.033 20.016L10.231 14H8.4L11.175 22H12.895L15.68 14H13.845L12.032 20.016H12.033ZM22.94 22V14H21.297V19.275L18.082 14H16.434V22H18.082V16.736L21.292 22H22.94ZM4 0H7V2H4V0ZM0 3H11L9 7H2L0 3ZM16.845 9L18.028 5.2H15.422L14.705 6.155H14L14.466 4.495L14 2.844H14.705L15.422 3.776H18.028L16.845 0H17.777L20.155 3.777H22.761C22.958 3.777 23.125 3.846 23.261 3.982C23.3283 4.04884 23.3812 4.12874 23.4165 4.21679C23.4517 4.30485 23.4686 4.39919 23.466 4.494C23.4679 4.5871 23.451 4.67963 23.4162 4.76603C23.3815 4.85243 23.3296 4.93091 23.2638 4.99676C23.1979 5.0626 23.1194 5.11446 23.033 5.14922C22.9466 5.18397 22.8541 5.20091 22.761 5.199H20.155L17.777 9H16.845Z'
                    fill='currentColor'
                />
            </G>
            <Defs>
                <ClipPath id='clip0_10859_99573'>
                    <Rect fill='currentColor' />
                </ClipPath>
            </Defs>
        </>
    ),
})

RvnIcon.displayName = 'RvnIcon'
